import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LanguageService {
  private _lang$ = new BehaviorSubject<string>(
    localStorage.getItem('app_lang') || 'vi',
  );
  public lang$ = this._lang$.asObservable();

  constructor(private translate: TranslateService) {}

  changeLang(lang: string) {
    // Ensure translations are loaded, then notify subscribers
    this.translate.use(lang).subscribe(() => {
      localStorage.setItem('app_lang', lang);
      this._lang$.next(lang);
      // Emit a DOM event so non-Angular code or third-party libs can react
      try {
        window.dispatchEvent(
          new CustomEvent('app-language-changed', {detail: {lang}}),
        );
      } catch (e) {
        // ignore environments where CustomEvent may not be constructable
      }
    });
  }
}
